import api from "./axiosInstance";
import { baseURL, createHeaders } from "./constants";

const contactUs = async (payload) => {
  return api.post(`${baseURL}/contact-uses`, { data: { ...payload }}, {headers: createHeaders()},);
};
export { contactUs };
